import countryBaseValidator from './country';

export default countryBaseValidator;
